export default {
    dashboard: 'Dashboard',
    github: 'Github',
    logOut: 'Log Out',
    profile: 'Profile',
    theme: 'Theme',
    size: 'Global Size',
    account: 'Account',
    businessUsers: 'Business Users',
    userName: 'User Name',
    currentRole: 'Current Role',
    personalInformation: 'Personal Information',
    changePassword: 'Change Password',
    tip_notChangePassword: 'Tip: The current account is not allowed to change the password',
    department: 'Department',
    mobileNumber: 'Mobile Number',
    pleaseEnterPhoneNumber: 'Please enter phone number',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm Password',
}